import { graphql } from 'react-relay';

export const profilePictureFragment = graphql`
    fragment ProfilePicture_picture on ProfilePicture {
        url
    }
`;
